// 代建與接手的純函式（M5-03）：步驟的文字鍵、安裝參數（Windows / GPO 啟動指令碼 / Intune / Linux / RMM）。
import type { Handover, HandoverStep } from './types';

/** 這一步此刻給誰按：viewer 是那個人才有按鈕，否則顯示「等〈人〉…」。 */
export function myTurn(h: Pick<Handover, 'viewer'>, s: HandoverStep): boolean {
  return s.state === 'todo' && h.viewer === s.actor;
}

/** 頁頂接手條：組織還在代建、而且我是代建者或接手客戶才畫。 */
export function showBanner(org: { built_by_partner?: string; built_by_user_id?: string; handover_user_id?: string } | null | undefined, me: string): boolean {
  return !!org?.built_by_partner && !!me && (org.built_by_user_id === me || org.handover_user_id === me);
}

/** 報到網址：plane API `https://api.<plane 網域>` → `https://device.<plane 網域>:9443`；推不出來回空（安裝包帶的那個 plane）。 */
export function enrollUrlFor(api: string): string {
  try {
    const u = new URL(api);
    if (!u.hostname.startsWith('api.')) return '';
    return `https://device.${u.hostname.slice(4)}:9443`;
  } catch {
    return '';
  }
}

export interface InstallParams {
  msiexec: string;
  intune: string;
  gpoScript: string;
  linux: string;
  rmm: string;
}

/** 安裝參數（SPEC #kinio-kms-onboarding「權杖建立後」；device/kmgr-agent docs/windows-deploy.md）。權杖只在這一頁出現一次。 */
export function installParams(token: string, enrollUrl: string, meta: { name: string; until: string; agent: string }): InstallParams {
  const url = enrollUrl ? ` ENROLL_URL="${enrollUrl}"` : '';
  const msi = 'kmgr-agent-win-x64.msi';
  const msiexec = `msiexec /i ${msi} /qn KMGR_TOKEN="${token}"${url}`;
  const gpoScript = [
    '@echo off',
    `rem ${meta.agent}：GPO 電腦啟動指令碼（權杖「${meta.name}」，到 ${meta.until}）`,
    'rem 放在只有 Domain Computers 讀得到的共用資料夾；網域使用者讀得到 = 把權杖交給所有網域使用者',
    'if exist "%ProgramFiles%\\Kinio\\kmgr-agent\\kmgr-agent.exe" exit /b 0',
    `msiexec /i "\\\\<檔案伺服器>\\deploy$\\kmgr-agent\\${msi}" /qn KMGR_TOKEN="${token}"${url}`,
    '',
  ].join('\r\n');
  const linux = `printf '%s' '${token}' | sudo kmgr-agent enroll --token-stdin${enrollUrl ? ' --enroll-url ' + enrollUrl : ''}`;
  const rmm = `KMGR_TOKEN=${token}${enrollUrl ? '\nENROLL_URL=' + enrollUrl : ''}`;
  return { msiexec, intune: msiexec, gpoScript, linux, rmm };
}
